import { getStageConfig } from './config';

export const getAmplifyConfig = () => {
  const config = getStageConfig();
  const userPoolId = config.cognitoAuthConfig.authority.split('/').pop() || '';
  
  return {
    Auth: {
      Cognito: {
        userPoolId: userPoolId,
        userPoolClientId: config.cognitoAuthConfig.client_id,
        identityPoolId: config.cognitoAuthConfig.identity_id,
        loginWith: {
          oauth: {
            domain: config.cognitoAuthConfig.cognito_domain.replace('https://', ''),
            scopes: config.cognitoAuthConfig.scope.split(' '),
            redirectSignIn: [config.cognitoAuthConfig.redirect_uri],
            redirectSignOut: [config.cognitoAuthConfig.logout_uri],
            responseType: 'code' as const
          }
        }
      }
    },
    API: {
      REST: {
        'PiperBridgeGateway': {
          endpoint: config.piperBridgeGatewayUrl
        }
      }
    }
  };
};